const encrypt = (strPlain) => {
  return strPlain
}

export default encrypt
